import React from "react";
import { withAlert } from "react-alert";
import { Link, withRouter } from "react-router-dom";

import ImgStart from "../image/btn_start.png";
import ImgStop from "../image/btn_stop.png";
import ImgSave from "../image/btn_save.png";

import "./design/default.css";
import "./design/style.css";

import SoldierInfo from "./soldierInfo";
import SoldierList from "./soldierList";
import StopWatch from "./setTime";

import DataSender from "../lib/DataSender";
import Loading from "./popup";
import Modal from "./modal";

class Measurement extends React.Component {
  constructor(props) {
    super(props);
    this.alert = props.alert;
    this.dummy = {
      id: "-1",
      name: "-",
      birth: "-",
      army_unit: { unitName: "-" },
      dt_number: "-",
      level: "-",
      count: 0,
      uncount: 0,
      loc: 1,
      ok: "○",
      health: {
        tempeture: "-",
        alcohol: "-",
        pulse: "-",
        garments: true,
      },
      image: "",
    };
    this.state = {
      soldiers: [],
      curSolider: this.dummy,
      runTime: 60,
      allCheck: false,
      time: false,
      running: false,
      show: false,
    };
    this.ds = new DataSender();
  }

  changeCur = (x) => {
    this.setState({ curSolider: x });
  };

  start = () => {
    this.setState({ running: !this.state.running });
    this.ds
      .trainStart({ seconds: this.state.runTime })
      .then((x) => x.json())
      .then((x) => {
        Object.entries(x).forEach(([k, v]) => {
          let ele = this.state.soldiers.find((x) => x.dt_number === k);
          ele.count = v[0];
          ele.uncount = v[1];
        });
      })
      .then(() => this.setState({ running: !this.state.running }))
      .catch((err) => {
        if (err.message === "Untokenized") alert("로그인 되지 않았습니다.");
      });
  };

  stop = () => {
    if (!this.state.running) {
      this.alert.show("측정이 시작되지 않았습니다.");
      return;
    }
    this.ds
      .trainStop()
      .then((x) => x.json())
      .then(() => this.setState({ running: false }))
      .catch((err) => {
        if (err.message === "Untokenized") alert("로그인 되지 않았습니다.");
      });
  };

  toggle = () => {
    if (this.state.curSolider === this.dummy) {
      this.alert.show("변경할 측정자를 선택해주세요.");
      return;
    }
    this.setState({ show: !this.state.show });
  };

  record = () => {
    try {
      let data = this.state.soldiers.map((x) => {
        if (x.count === "-") throw new Error();
        return { id: x.id, count: x.count, uncount: x.uncount, type: "P" };
      });

      this.ds.insertTrain({ data }).then((x) => {
        this.alert.show("등록이 완료되었습니다.");
      });
    } catch (err) {
      this.alert.show("측정이 되지 않아 등록할수 없습니다.");
    }
  };

  render() {
    return (
      <section className="sec">
        <div style={{ display: this.state.running ? "block" : "none" }}>
          <Loading />
        </div>
        <nav>
          <ul>
            <li>
              <Link to="#">
                <div></div>
                <span>윗몸일으키기</span>
              </Link>
            </li>
            <li className="on">
              <Link to="#">
                <div></div>
                <span>팔굽혀펴기</span>
              </Link>
            </li>
          </ul>
        </nav>
        <div className="con">
          <SoldierInfo curSolider={this.state.curSolider} />

          <SoldierList
            {...this.state}
            changeCur={this.changeCur}
            measur={this}
          />

          <StopWatch measur={this} />

          <div className="controller">
            <div
              className="button"
              id="startBtn"
              onClick={this.start.bind(this)}
            >
              <Link to="#">
                <span>
                  <img src={ImgStart} alt="시작 아이콘" />
                  시작
                </span>
              </Link>
            </div>
            <div className="button" id="stopBtn" onClick={this.stop}>
              <Link to="#">
                <span>
                  <img src={ImgStop} alt="정지 아이콘" />
                  정지
                </span>
              </Link>
            </div>
            <div className="button" id="saveBtn" onClick={this.record}>
              <Link to="#">
                <span>
                  <img src={ImgSave} alt="저장 아이콘" />
                  저장
                </span>
              </Link>
            </div>
          </div>
        </div>
        <Modal show={this.state.show} toggle={this.toggle} />
      </section>
    );
  }
}

export default withAlert()(withRouter(Measurement));
